import Modal from "../Elements/Modal"
import { useShopId } from "../../hooks/shop"
import OrderFormCreateOrUpdate from "./OrderFormCreateOrUpdate"
import { useShopSalePointId } from "../../hooks/shopSalePoint"
import { useShopPaymentPointId } from "../../hooks/shopPaymentPoint"

interface Props {
  isOpen: boolean
  setOpen: any
  cancelButtonRef: any

  onSubmit: any
  onCancel: any
}

const OrderModalCreate = ({
  isOpen,
  setOpen,
  cancelButtonRef,
  onSubmit,
  onCancel,
}: Props) => {
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()

  return (
    <Modal isOpen={isOpen} setOpen={setOpen} cancelButtonRef={cancelButtonRef}>
      <OrderFormCreateOrUpdate
        onSubmit={onSubmit}
        onCancel={onCancel}
        shopId={shopId}
        shopSalePointId={shopSalePointId}
      />
    </Modal>
  )
}

export default OrderModalCreate
